import React from 'react';
import { CorporateTheme } from '../../../utils/themes';
import CustomInput from '../../form/CustomInput';
import { FieldLabel } from './FieldSettingsModal';
import { useTheme } from '../../../middleware/ThemeContext';
interface PlaceholderSettingsProps {
    isCompoundField: boolean;
    placeholder: string;
    setPlaceholder: (value: string) => void;
    fieldConfigs?: any[];
    updateFieldProperty?: (key: string, property: string, value: any) => void;
}

export const PlaceholderSettings: React.FC<PlaceholderSettingsProps> = ({
    isCompoundField,
    placeholder,
    setPlaceholder,
    fieldConfigs = [],
    updateFieldProperty = () => { },
}) => { 
    const { theme } = useTheme();
    return(
    <div className="px-3 py-2">
        <FieldLabel theme={theme}>
            {isCompoundField ? "Configure Placeholder Text" : "Placeholder Settings"}
        </FieldLabel>

        {isCompoundField ? (
            fieldConfigs.map((field: any) => (
                <div key={field.key} className="mb-3">
                    <FieldLabel theme={theme}>
                        {field.label}
                    </FieldLabel>
                    <div className="d-flex align-items-center gap-2">
                        <CustomInput
                            className="flex-grow-1"
                            type="text"
                            value={field.placeholder || ''}
                            onChange={(val) => updateFieldProperty(field.key, 'placeholder', val)}
                            placeholder={`Enter placeholder for ${field.label}`}
                        />
                    </div>
                </div>
            ))
        ) : (
            <CustomInput
                className="flex-grow-1"
                type="text"
                value={placeholder}
                onChange={setPlaceholder}
                placeholder="Enter placeholder text"
            />
        )}
    </div>
);
};